import { render, staticRenderFns } from "./VehicleProfile.vue?vue&type=template&id=2229c5f6&scoped=true&"
import script from "./VehicleProfile.vue?vue&type=script&lang=ts&"
export * from "./VehicleProfile.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleProfile.vue?vue&type=style&index=0&id=2229c5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2229c5f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VOverlay,VProgressCircular,VRow})
